import { paymentMethodCodes } from '../../../constants/paymentMethods';

export const KLARNA = 'klarna' as const;

export const klarnaCategories = {
  [paymentMethodCodes.KLARNA_ONE]: KLARNA,
  [paymentMethodCodes.KLARNA_PAY_LATER]: 'pay_later',
  [paymentMethodCodes.KLARNA_PAY_NOW]: 'pay_now',
  [paymentMethodCodes.KLARNA_SLICE_IT]: 'pay_over_time',
  [paymentMethodCodes.KLARNA_SOFORT]: 'pay_now',
} as const;

export const klarnaCodes = Object.keys(klarnaCategories);
